export enum BillingRateEnum {
  PER_HOUR = 'PER_HOUR',
  PER_DAY = 'PER_DAY',
}
